<!--
 * @Author: Junjie
 * @Date: 2022-11-25 14:49:54
 * @LastEditTime: 2022-11-25 18:04:03
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/monitor/ControlSysTemLan.vue
-->
<template>
  <div class="page-container">
    <div class="flex h-full">
      <iframe-f-report-view
        :src="iframeSrc"
        :style="{width: iframeStyle.width, height: iframeStyle.height}"
        allowfullscreen="true"
        frameborder="0"
      ></iframe-f-report-view>
    </div>
  </div>
</template>
<script>
  import IframeFReportView from '@/components/layouts/IframeFReportView.vue';
  import { mixinDevice } from '@/utils/mixin.js';
  import { getAction } from '@/api/manage';
  import { mapGetters, mapActions } from 'vuex'

  export default {
    components: {
      IframeFReportView
    },
    mixins: [mixinDevice],
    data () {
      return {
        name: 'ControlSysTemLan',
        iframeSrc: '',
        iframeStyle: {},
        categoryCode: 'A04A01',
        iframeConf: {},
        url: {
          getCategoryList: '/custom/category/childList',
        }
      }
    },
    created () {
      this.getIframeConfig();
    },
    mounted () {
      //   this.mainInfoHeight = (window.innerHeight - 285) + "px";
    },
    computed: {
      ...mapGetters(['permissionList']),
    },

    methods: {
      getIframeConfig () {
        getAction(this.url.getCategoryList, {
          code: this.categoryCode,
        }).then((res) => {
          if (res.success) {
            if (res.result.length == 0) {
              this.$message.warning('公共编码配置不正确，请联系管理员')
              return;
            } else {
              this.iframeConf = res.result[0];
              this.renderIframe();
            }
          } else {
            this.$message.warning('公共编码配置不正确，请联系管理员')
          }
        });
      },

      async renderIframe () {
        /**
       *  //TODO  
       *  1. cusProp1 是内网url；cusProp2是外网url地址，按顺序使用优先级；
       *  2. cusProp3是iframe的css style json， 需要支持两种：指定宽高像素、充满当前父容器
       */
        const innerNetUrl = this.iframeConf.cusProp1;
        const publicNetUrl = this.iframeConf.cusProp2;
        this.iframeStyle = this.iframeConf.cusProp3;
        const res = await getAction(innerNetUrl).then((data) => {
          return data;
        }).catch((e) => {
          console.error(e)
          this.$message.error('获取HTTP信息失败')
        });
        if (res) {
          this.iframeSrc = innerNetUrl;
          return;
        }
        const publicRes = await getAction(publicNetUrl).then((data) => {
          return data;
        }).catch((e) => {
          console.error(e)
          this.$message.error('获取HTTP信息失败')
        });
        if (publicRes) {
          this.iframeSrc = publicNetUrl;
          return;
        }
        this.$message.warning('您没有权限访问此页面');
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '~@assets/less/common.less';
</style>